import {ICreatedRoom, ICreateRoom, IUpdateRoom, IFetchRoom} from '../incase-domain/rooms/room.editor';
import {httpGet, httpPost, httpPut} from './http.service';
import {SORT} from '../incase-domain/common/sort.enum';
import {IPaginatedResult} from '../incase-domain/search';
import {roomSocket} from '../utils/socket';

export const fetchRoomsListPaginated = (
    pageNumber: number,
    pageSize: number,
    searchTerm?: string,
    sortBy?: Record<string, SORT>
): Promise<IPaginatedResult<IFetchRoom>> => {
    let params = {};

    if (searchTerm) params = {...params, searchTerm};
    if (sortBy) params = {...params, ...sortBy};

    return httpGet(`editor/rooms/${pageNumber}/${pageSize}`, {params});
};

export const createRoomService = (room: ICreateRoom): Promise<ICreatedRoom> => {
    return httpPost(`editor/rooms/newRoom`, {room});
};

export const fetchRoomService = (roomId: string): Promise<IFetchRoom> => {
    return httpGet(`editor/rooms/${roomId}`);
};

export const fetchRoomsForPresentation = (presentationId: string): Promise<IFetchRoom[]> => {
    return httpGet(`editor/rooms/findByPresentation/${presentationId}`);
};

export const fetchRoomsIdentifications = (roomId: string, searchTerm = ''): Promise<string[]> => {
    return httpGet(`editor/rooms/identifications/${roomId}?searchTerm=${searchTerm}`);
};

export const updateRoomService = (room: IUpdateRoom): Promise<IUpdateRoom> => {
    return httpPut(`editor/rooms/updateRoom/${room._id}`, {room});
};

export const deleteRoomService = (roomId: string): Promise<{success: boolean}> => {
    return httpPost(`editor/rooms/delete/${roomId}`, {}, {})
        .then(() => ({success: true}))
        .catch(() => {
            return {success: false};
        });
};

export const bulkDeleteRoomService = (arrOfRoomsId: string[]): Promise<{success: boolean}> => {
    return httpPost(`editor/rooms/delete`, {arrOfRoomsId}, {})
        .then(() => ({success: true}))
        .catch(() => {
            return {success: false};
        });
};

export const duplicateRoomsService = (roomIds: string[]): Promise<ICreatedRoom[]> => {
    return httpPost('editor/rooms/duplicate', {roomIds});
};

export function stopRoom(): void {
    roomSocket && roomSocket.emit('stopRoom');
}

export const fetchRoomSocketToken = (roomId: string): Promise<{socketToken: string}> => {
    return httpGet(`editor/rooms/${roomId}/socket-token`);
};

export const resendInvitationService = (roomId: string): Promise<{outboxMessageId: string}> => {
    return httpPost(`editor/rooms/${roomId}/resend-invitation`, {});
};
